export const annualPlan = {
  // Page
  annualPlanTitle: 'Plan Anual',
  annualPlanSubtitle: 'Planifica tu año con ayuda de IA',
  annualPlanDescription: 'Crea tu plan anual guiado por inteligencia artificial',
  planYourYear: 'Planifica tu año con metas claras',

  // Steps
  stepWelcome: 'Bienvenida',
  stepReflection: 'Reflexión',
  stepLifeAreas: 'Áreas de Vida',
  stepGoals: 'Metas',
  stepReview: 'Revisión',
  stepSummary: 'Resumen',

  // Welcome
  welcomeBadge: 'Plan {year}',
  welcomeTitle: 'Diseña tu Mejor Año',
  welcomeDescription: 'Te guiaré paso a paso para crear un plan anual significativo y alcanzable. Juntos reflexionaremos sobre el año que termina y construiremos metas claras para el próximo.',
  welcomeFeature1Title: 'Reflexión Guiada',
  welcomeFeature1Desc: 'Analiza tus logros y aprendizajes del año',
  welcomeFeature2Title: 'Metas SMART',
  welcomeFeature2Desc: 'La IA te ayuda a crear metas específicas y medibles',
  welcomeFeature3Title: 'Recordatorios',
  welcomeFeature3Desc: 'Configura revisiones trimestrales automáticas',
  welcomeFeature4Title: 'Sugerencias IA',
  welcomeFeature4Desc: 'Recibe ideas personalizadas basadas en tu reflexión',
  startPlanning: 'Comenzar Planificación',
  welcomeTimeEstimate: 'Aproximadamente 15-30 minutos',

  // Reflection
  reflectionIntro: '¡Hola! Antes de planificar el próximo año, tomemos un momento para reflexionar sobre el año que está terminando. Esto nos ayudará a crear un plan más significativo y alineado con tus experiencias.',
  reflection_achievements: '¿Cuáles fueron tus mayores logros?',
  reflection_achievements_placeholder: 'Proyectos completados, metas alcanzadas, momentos de orgullo...',
  reflection_challenges: '¿Qué desafíos enfrentaste?',
  reflection_challenges_placeholder: 'Obstáculos superados, dificultades que te hicieron crecer...',
  reflection_learnings: '¿Qué aprendiste este año?',
  reflection_learnings_placeholder: 'Lecciones de vida, habilidades nuevas, insights personales...',
  reflection_gratitude: '¿Por qué estás agradecido/a?',
  reflection_gratitude_placeholder: 'Personas, experiencias, oportunidades que agradeces...',
  getAIInsights: 'Obtener Insights de IA',

  // Life Areas
  lifeAreasIntro: 'Excelente reflexión. Ahora identifiquemos las áreas de tu vida en las que quieres enfocarte el próximo año. Selecciona las que son prioritarias para ti.',
  selectLifeAreas: 'Áreas de Vida Sugeridas',
  addCustomArea: 'Agregar área personalizada...',
  selectedAreas: 'Áreas Seleccionadas',
  aiSuggestedAreas: 'Basado en tu reflexión, te sugiero enfocarte en:',
  getAreaSuggestions: 'Obtener sugerencias de áreas',
  
  // Area names
  area_health: 'Salud',
  area_career: 'Carrera',
  area_finances: 'Finanzas',
  area_relationships: 'Relaciones',
  area_personal_growth: 'Crecimiento Personal',
  area_hobbies: 'Hobbies',
  area_spirituality: 'Espiritualidad',
  area_home: 'Hogar',
  area_legal: 'Legales',

  // Goals
  goalsIntro: 'Ahora vamos a definir metas específicas para cada área que seleccionaste. Te ayudaré con sugerencias basadas en tu reflexión.',
  goalsCreated: 'metas creadas',
  areasWithGoals: 'áreas con metas',
  yourGoals: 'Tus Metas',
  aiSuggestedGoals: 'Sugerencias de IA para esta área:',
  addNewGoal: 'Agregar Nueva Meta',
  goalTitle: 'Título de la Meta',
  goalTitlePlaceholder: 'Ej: Correr un maratón',
  goalDescription: 'Descripción (opcional)',
  goalDescriptionPlaceholder: 'Detalles adicionales sobre la meta...',
  targetQuarter: 'Trimestre Objetivo',
  addGoal: 'Agregar Meta',
  suggestGoalsForArea: 'Sugerir metas para esta área',
  goals: 'metas',

  // Review
  reviewIntro: '¡Excelente trabajo! Has creado {count} metas para el próximo año. Revisa tu plan antes de guardarlo.',
  noGoalsYet: 'Sin metas todavía',
  edit: 'Editar',
  createQuarterlyReminders: 'Crear recordatorios trimestrales',
  quarterlyRemindersDescription: 'Recibirás un recordatorio al inicio de cada trimestre para revisar tu progreso.',
  quarterlyReview: 'Revisión Trimestral',
  quarterlyReviewDescription: 'Es momento de revisar tu progreso en las metas del plan anual.',
  saveAndFinish: 'Guardar y Finalizar',
  saving: 'Guardando...',
  planSaved: 'Plan Guardado',
  planSavedDescription: 'Se crearon {count} metas exitosamente.',
  errorSavingPlan: 'Error al guardar el plan',

  // Summary
  congratulations: '¡Felicitaciones!',
  planComplete: 'Tu plan para {year} está listo',
  summaryMessage: 'Has creado un plan completo con {count} metas en {areas} áreas de tu vida. Tus metas están guardadas y los recordatorios configurados. ¡Mucho éxito en el próximo año!',
  lifeAreas: 'áreas de vida',
  remindersSet: 'recordatorios',
  planYear: 'año del plan',
  exportPlan: 'Exportar Plan',
  exportSuccess: 'Exportación exitosa',
  pdfDownloaded: 'El PDF se ha descargado',
  docxDownloaded: 'El documento Word se ha descargado',
  exportError: 'Error al exportar',
  print: 'Imprimir',
  nextSteps: 'Próximos Pasos',
  viewGoals: 'Ver mis Metas',
  viewReminders: 'Ver Recordatorios',
  startNewPlan: 'Crear Nuevo Plan',
  goToDashboard: 'Ir al Dashboard',

  // Common
  back: 'Atrás',
  continue: 'Continuar',
  error: 'Error',

  // Auto-save
  autoSaving: 'Guardando...',
  savedAt: 'Guardado',
  saveError: 'Error al guardar',
  autoSaveEnabled: 'Auto-guardado activo',
  justNow: 'ahora mismo',
  minutesAgo: 'min atrás',
  hoursAgo: 'h atrás',
  draftFound: 'Borrador encontrado',
  draftFoundMessage: 'Se encontró un borrador guardado. ¿Deseas continuar donde lo dejaste?',
  continueDraft: 'Continuar borrador',
  startFresh: 'Empezar de nuevo',

  // Area Reflection Questions
  areaReflectionTitle: 'Reflexión sobre esta área',
  areaReflectionDescription: 'Antes de definir tus metas, reflexiona brevemente sobre esta área de tu vida:',
  areaReflection_keep: '¿Qué mantener?',
  areaReflection_keep_placeholder: 'Hábitos o prácticas que funcionan bien...',
  areaReflection_reduce: '¿Qué reducir?',
  areaReflection_reduce_placeholder: 'Excesos que quieres moderar...',
  areaReflection_increase: '¿Qué aumentar?',
  areaReflection_increase_placeholder: 'Cosas positivas que quieres potenciar...',
  areaReflection_eliminate: '¿Qué eliminar?',
  areaReflection_eliminate_placeholder: 'Cosas que no aportan valor...',
  areaReflection_implement: '¿Qué implementar?',
  areaReflection_implement_placeholder: 'Nuevas iniciativas a comenzar...',
};
